module.exports = __webpack_public_path__ + "img/reworked_dark.793aa219.svg";